import React from "react";

const Dental = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Dental Availment</h1>
      <div className='description'>
        How to avail dental services:
        <ul id='mainList'>
          <li className='list-item bullet'>
            Member checks the list of Getwell’s-accredited clinic (refer to list
            of accredited dental clinic)
          </li>
          <li className='list-item bullet'>
            Member calls the dental clinic of his choice to set for an
            appointment for availment of dental benefits
          </li>
          <li className='list-item bullet'>
            Member proceeds to the clinic on the day of your dental availment
          </li>
          <li className='list-item bullet '>
            Member presents his Getwell card or 2 valid Id’s for verification.
          </li>
          <li className='list-item bullet'>
            Dental clinic calls Getwell office for the verification of
            membership status.
          </li>
          <li className='list-item bullet'>
            If membership status is <b>ACTIVE</b>, Getwell staff gives approval
            for the entitled dental benefits If <b>INACTIVE</b>, member is
            denied and advised to call their employer for his/her membership
            status
          </li>
          <li className='list-item bullet'>
            Member avails the entitled dental benefits
          </li>
          <li className='list-item bullet'>
            Note: only 2 management per visit
          </li>
          <li className='list-item bullet'>
            Member signs the Dental Availment Summary
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Dental;
